const retryBlacklist = [''];

export default retryBlacklist;
